import PropTypes from "prop-types"

// Question shape for PropTypes validation
const questionShape = PropTypes.shape({
  questionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  question: PropTypes.string.isRequired,
  answerType: PropTypes.oneOf(['Single Select', 'Multi Select', 'Mixed Select', 'Text']).isRequired,
  order: PropTypes.number,
  isRequired: PropTypes.bool,
  isVisibleToBorrower: PropTypes.bool,
  borrowerId: PropTypes.number,
  isDemographicInformation: PropTypes.bool,
  answer: PropTypes.string,
  selectedOptions: PropTypes.arrayOf(PropTypes.number),
  declarationId: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    optionId: PropTypes.number.isRequired,
    optionType: PropTypes.string,
    optionText: PropTypes.string.isRequired,
    metaData: PropTypes.shape({
      buttonType: PropTypes.oneOf(['Single Select', 'Multi Select'])
    }),
    targetQuestions: PropTypes.array // Recursive array of questions
  }))
})

export { questionShape }
